import { generateAbsenceHoursBody, PatchAbsenceHourData } from '../../../helpers/api-ts/absenceHour'
import { authorizedFetch } from '../../helpers/authorizedFetch'
import trans from '../../helpers/trans'
import { generateApiUrl } from '../../helpers/url'
import { JapiDocument } from '../../japi/types/Document'
import { FetchResult, FetchResultType } from '../FetchResult'
import { NotificationCenterHeaderName, NotificationCenterLog } from '../NotificationCenter/NotificationCenter'

export const postAbsenceHoursApiCall = async (
    absenceId: string,
    eventLogTrackerData: NotificationCenterLog,
    payrollPeriodId: string | undefined,
    hours: number | null = null,
    weekNumber: number,
    waitingDayHours?: number,
): Promise<FetchResult<any, string>> => {
    // TODO: this can be a collection endpoint
    try {
        const includes = ['payrollPeriod']

        const url = generateApiUrl({
            endpoint: '/absence-hours',
            queryParams: {
                include: includes.join(','),
            },
        })

        const response = await authorizedFetch(url, {
            method: 'POST',
            body: JSON.stringify({
                data: generateAbsenceHoursBody(
                    absenceId,
                    payrollPeriodId,
                    hours,
                    weekNumber,
                    waitingDayHours,
                ),
            }),
            headers: {
                [NotificationCenterHeaderName.X_EVENT]: JSON.stringify(eventLogTrackerData),
            },
        })

        const doc: JapiDocument = await response.json()

        // TODO: return the absence hour or hours

        if (! response.ok) {
            return {
                status: response.status,
                type: FetchResultType.Error,
                error: doc.errors?.[0].detail || trans('errors.unknownError'),
            }
        }

        return {
            status: response.status,
            type: FetchResultType.Success,
            data: {},
        }
    } catch (error) {
        console.error('[postAbsenceHoursApiCall]', error)

        return {
            status: 500,
            type: FetchResultType.Error,
            error: trans('errors.unknownError'),
        }
    }
}

export const patchAbsenceHoursApiCall = async (
    data: PatchAbsenceHourData[],
    eventLogTrackerData: NotificationCenterLog,
): Promise<FetchResult<any, string>> => {
    try {
        // TODO: remove temporary fix for patch on collection endpoint until the absence hours endpoint is fixed
        const url = generateApiUrl({
            endpoint: '/absence-hours',
        }).split('?')[0]

        const response = await authorizedFetch(url, {
            method: 'PATCH',
            body: JSON.stringify({
                data: [
                    ...data.map(item => generateAbsenceHoursBody(
                        item.absenceId,
                        item.payrollPeriodId,
                        item.hours,
                        item.weekNumber,
                        item.waitingDayHours,
                        item.id,
                    )),
                ],
            }),
            headers: {
                [NotificationCenterHeaderName.X_EVENT]: JSON.stringify(eventLogTrackerData),
            },
        })

        const doc: JapiDocument = await response.json()

        // TODO: return the absence hour once the endpoint is fixed

        if (! response.ok) {
            return {
                status: response.status,
                type: FetchResultType.Error,
                error: doc.errors[0].detail || trans('errors.unknownError'),
            }
        }

        return {
            status: response.status,
            type: FetchResultType.Success,
            data: {},
        }
    } catch (error) {
        console.error('[patchAbsenceHoursApiCall]', error)

        return {
            status: 500,
            type: FetchResultType.Error,
            error: trans('errors.unknownError'),
        }
    }
}

export const deleteAbsenceHoursApiCall = async (
    absenceHourId: string,
    eventLogTrackerData: NotificationCenterLog,
): Promise<FetchResult<any, string>> => {
    try {
        const url = generateApiUrl({
            endpoint: `/absence-hours/${absenceHourId}`,
        })

        const response = await authorizedFetch(url, {
            method: 'DELETE',
            headers: {
                [NotificationCenterHeaderName.X_EVENT]: JSON.stringify(eventLogTrackerData),
            },
        })

        if (! response.ok) {
            return {
                status: response.status,
                type: FetchResultType.Error,
                error: trans('errors.unknownError'),
            }
        }

        return {
            status: response.status,
            type: FetchResultType.Success,
            data: {},
        }
    } catch (error) {
        console.error('[deleteAbsenceHoursApiCall]', error)

        return {
            status: 500,
            type: FetchResultType.Error,
            error: trans('errors.unknownError'),
        }
    }
}
